import GlobalNavbarEN from '../../../components/feature/GlobalNavbarEN';
import FooterEN from '../../home/components/FooterEN';

export default function PrivacyPolicyEN() {
  return (
    <div className="min-h-screen bg-white">
      <GlobalNavbarEN />
      
      {/* Dark Hero Banner - matches other pages */}
      <section className="relative bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 pt-32 pb-16 px-6">
        <div className="max-w-[900px] mx-auto">
          <h1 className="text-4xl font-bold text-white mb-4">Privacy Policy</h1>
          <p className="text-sm text-gray-400">Last Updated: January 2026</p>
        </div>
      </section>

      <main className="py-20">
        <div className="max-w-[900px] mx-auto px-8">
          <div className="space-y-8 text-gray-700">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Introduction</h2>
              <p className="leading-relaxed">
                DOOHNUTS Inc. ("Company," "we," "us," or "our") considers the protection of personal information of all users of our website and services to be a critical responsibility.
              </p>
              <p className="leading-relaxed mt-4">
                This Privacy Policy explains what information we collect, how we use it, how we manage it, and the rights of users.
              </p>
              <p className="leading-relaxed mt-4">
                This Policy is intended to comply with applicable U.S. federal and state laws.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Information We Collect</h2>
              <p className="leading-relaxed mb-4">
                We may collect the following information:
              </p>
              
              <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">(1) Information You Provide Directly</h3>
              <p className="leading-relaxed mb-3">
                Information provided through contact forms or application procedures:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Name</li>
                <li>Company name (if applicable)</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Property or billboard information</li>
                <li>Advertising budget, campaign details</li>
                <li>Other voluntarily provided information</li>
              </ul>

              <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">(2) Communication Information</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Inquiry content</li>
                <li>Records of communications with us</li>
              </ul>

              <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">(3) Technical Information</h3>
              <p className="leading-relaxed mb-3">
                Information automatically collected when using the website:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>IP address</li>
                <li>Browser type</li>
                <li>Device information</li>
                <li>Access date and time</li>
                <li>Page browsing history</li>
                <li>Usage data collected through cookies and similar technologies</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Purpose of Use</h2>
              <p className="leading-relaxed mb-4">
                We use the collected information for the following purposes:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Responding to inquiries</li>
                <li>Providing services and fulfilling contracts</li>
                <li>Executing advertising placements and partnership operations</li>
                <li>Improving services and optimizing the website</li>
                <li>Providing marketing information (opt-out available)</li>
                <li>Complying with laws and protecting our rights</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Information Sharing and Disclosure</h2>
              <p className="leading-relaxed mb-4">
                We do not sell personal information.
              </p>
              <p className="leading-relaxed mb-4">
                We may share information only in the following cases:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Service providers (hosting companies, payment processors, etc.)</li>
                <li>Advertising delivery and operational partners (with user consent)</li>
                <li>When required by law</li>
                <li>In the event of business transfer, merger, or acquisition</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Cookies and Similar Technologies</h2>
              <p className="leading-relaxed mb-4">
                We may use cookies and similar technologies to improve website usability and analyze usage patterns.
              </p>
              <p className="leading-relaxed mb-4">
                This may include third-party analytics tools.
              </p>
              <p className="leading-relaxed">
                Users can control or reject cookies through browser settings.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. User Rights</h2>
              <p className="leading-relaxed mb-4">
                Within the scope of applicable laws, users may have the following rights:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Request access to personal information we hold</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of personal information</li>
                <li>Opt-out of marketing communications</li>
                <li>Object to certain processing activities</li>
              </ul>
              <p className="leading-relaxed mt-4">
                To exercise your rights, please contact us using the information below.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Data Retention Period</h2>
              <p className="leading-relaxed mb-4">
                We retain personal information for the period necessary to achieve the purposes stated in this Policy.
              </p>
              <p className="leading-relaxed">
                Except where required by law, unnecessary information will be securely deleted or anonymized.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Data Security</h2>
              <p className="leading-relaxed mb-4">
                We implement reasonable technical and organizational security measures to prevent unauthorized access, disclosure, alteration, or destruction of personal information.
              </p>
              <p className="leading-relaxed mb-4">
                Access to personal information is limited to authorized personnel only.
              </p>
              <p className="leading-relaxed">
                However, no method of transmission over the Internet is completely secure.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. External Links</h2>
              <p className="leading-relaxed mb-4">
                Our website may contain links to third-party websites.
              </p>
              <p className="leading-relaxed">
                We are not responsible for the privacy practices of external websites.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Information from Minors</h2>
              <p className="leading-relaxed mb-4">
                Our services are not intended for individuals under 18 years of age.
              </p>
              <p className="leading-relaxed">
                We do not knowingly collect personal information from minors.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Changes to This Policy</h2>
              <p className="leading-relaxed mb-4">
                We may update this Policy from time to time.
              </p>
              <p className="leading-relaxed mb-4">
                When changes are made, we will notify you on this page and update the "Last Updated" date.
              </p>
              <p className="leading-relaxed">
                Continued use of our services after changes constitutes acceptance of the updated Policy.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">12. Contact Information</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="font-semibold text-gray-900 mb-2">DOOHNUTS Inc.</p>
                <p className="text-gray-700">Las Vegas, Nevada</p>
                <p className="text-gray-700">Email: info@doohnutsinc.com</p>
                <p className="text-gray-700">Phone: +1 (702) 477-9870</p>
              </div>
            </section>
          </div>
        </div>
      </main>

      <FooterEN />
    </div>
  );
}
